// @flow
import axios from "axios";
import { BASE_URL_API } from "../store";
import modelCalendar from "../models/calendar";

import type { AuctionsApiItem } from "../models/auction";

export type CalendarApiItem = AuctionsApiItem;
export type CalendarApiData = Array<CalendarApiItem>;

export const calendar = (locale: string) => async () => {
  const response = await axios.get(`${BASE_URL_API}/v1/calendar`, {
    params: { locale: locale }
  });
  if (response.statusText === "OK") {
    let data = (response.data: CalendarApiData);

    return (data || []).filter(i => i.auc_show_in_calendar).map(modelCalendar);
  } else {
    throw response.status;
  }
};



// WEBPACK FOOTER //
// ./src/redux/api/calendar.js